import '#/assets/css/main.css';

import { render } from 'react-dom';

import App from '#/App';
import O11y, { initO11y } from '#/utils/o11y';
import { initDayjs } from '#/utils/dayjs';

initO11y();
initDayjs();

const container = document.getElementById('root');

render(
  <O11y.ErrorBoundary fallback={<p>Sorry, something went wrong.</p>}>
    <App />
  </O11y.ErrorBoundary>,
  container,
);
